var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8929 12.6454C25.8929 19.6292 20.0966 25.2907 12.9464 25.2907C5.79632 25.2907 0 19.6292 0 12.6454C0 5.66152 5.79632 0 12.9464 0C20.0966 0 25.8929 5.66152 25.8929 12.6454ZM18.4066 7.67032L5.92404 12.3712C5.0685 12.6979 5.0836 13.1605 5.77732 13.3755L8.97293 14.3492L16.3858 9.79053C16.73 9.56713 17.0494 9.69358 16.7883 9.91803L10.7897 15.2112L10.5599 18.4284C10.8944 18.4284 11.04 18.2861 11.2127 18.1175L12.7738 16.6485L16.0104 18.9784C16.6005 19.3051 17.0224 19.1365 17.1799 18.4431L19.3053 8.66298L19.3042 8.66404C19.4919 7.80837 18.9859 7.46589 18.4066 7.67032Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGrey);
export default __webpack_public_path__ + "static/media/x_grey.a0ef12108137164b579ec1f02b5df1a6.svg";
export { ForwardRef as ReactComponent };